import { render, staticRenderFns } from "./VehicleProfile.vue?vue&type=template&id=08d6543c&scoped=true&"
import script from "./VehicleProfile.vue?vue&type=script&lang=js&"
export * from "./VehicleProfile.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProfile.vue?vue&type=style&index=0&id=08d6543c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6543c",
  null
  
)

export default component.exports